import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import SiteHeader from '../components/header/site-header';

const styles = {
  down__page: {
    width: '100%',
  },
  text__center: {
    textAlign: 'center',
  },
};

class DownPage extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.down__page}>
        <SiteHeader />
        <div>
          <h2 className={classes.text__center}>We&apos;re sorry!</h2>
          <p className={classes.text__center}>
            We&apos;re currently down for maintenance. We expect to be back up shortly. Thank you for your patience.
          </p>
        </div>
      </div>
    );
  }
}

DownPage.propTypes = {
  classes: PropTypes.object,
};

export default injectSheet(styles)(DownPage);
